import posthog from 'posthog-js';

let posthogInitialized = false;

// Initialize PostHog
export const initPostHog = () => {
  if (typeof window !== 'undefined' && !posthogInitialized) {
    try {
      const apiKey = 'phc_JynwRBiXbRLvSgAMxolZIAzI9KrT7OYGf2uNJT1zQhr';

      // Verify API key format
      if (!apiKey || !apiKey.startsWith('phc_')) {
        console.error('❌ Invalid PostHog API key format. Should start with "phc_"');
        return posthog;
      }

      posthog.init(apiKey, {
        api_host: 'https://eu.i.posthog.com', // PostHog EU endpoint
        // Enable session recordings
        session_recording: {
          enabled: true,
          recordCrossOriginIframes: true,
        },
        // Capture page views automatically
        capture_pageview: true,
        // Capture performance metrics
        capture_performance: true,
        // Enable autocapture for clicks and form interactions
        autocapture: true,
        // Capture time spent on page automatically
        capture_pageleave: true,
        // Disable toolbar
        disable_toolbar: true,
        // Wait for PostHog to be ready
        loaded: (ph) => {
          console.log('✅ PostHog initialized successfully');
          console.log('PostHog instance:', ph);
        },
        // Ensure events are sent
        persistence: 'localStorage+cookie',
        // Debug mode in development
        debug: process.env.NODE_ENV === 'development',
      });

      posthogInitialized = true;
      console.log('🚀 PostHog initialization started');

      // Expose PostHog to window for debugging
      if (typeof window !== 'undefined') {
        window.posthog = posthog;
      }
    } catch (error) {
      console.error('❌ Failed to initialize PostHog:', error);
    }
  }
  return posthog;
};

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!posthogInitialized || !posthog || typeof posthog.capture !== 'function') {
      console.warn('⚠️ PostHog not initialized yet, event not tracked:', eventName);
      return;
    }

    posthog.capture(eventName, properties);
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Event tracked:', eventName, properties);
    }
  } catch (error) {
    console.error('❌ Failed to track event:', eventName, error);
  }
};

// Identify a user (when you know who they are)
export const identifyUser = (email, properties = {}) => {
  if (typeof window !== 'undefined' && posthogInitialized) {
    try {
      posthog.identify(email, properties);
    } catch (error) {
      console.error('Failed to identify user:', error);
    }
  }
};

export default posthog;
